export const getSPQLLoading = (state) => state.deepScan.resultsStatus;

export const getSPQLFieldsMetadata = (state) => state.deepScan.fieldsMetadata;
export const getSPQLQuery = (state) => state.deepScan.query;
export const getQueryExamples = (state) => state.deepScan.queryExamples;
export const getQueryExamplesLoadingStatus = (state) =>
  state.deepScan.queryExamplesStatus;
export const getSPQLCreateQueryStatus = (state) =>
  state.deepScan.saveSPQLQueryStatus;
export const getSPQLCreateQueryError = (state) =>
  state.deepScan.saveSPQLQueryError;
export const getSPQLSavedQueries = (state) => state.deepScan.savedSPQLQueries;
export const getSPQLSorting = (state) => state.deepScan.sorting;
export const getSPQLCurrentPage = (state) => state.deepScan.currentPage;
export const getSPQLRecentQueries = (state) =>
  state.deepScan.recentlyRanQueries;
export const getSPQLRecentQueriesLoadingStatus = (state) =>
  state.deepScan.recentlyRanQueriesStatus;
export const getSPQLSelectedColumns = (state) =>
  state.deepScan.defaultDisplayFields;
export const getSPQLSortableFields = (state) => state.deepScan.sortableFields;
export const getSPQLAvailableFields = (state) => state.deepScan.availableFields;
export const getSPQLQueryValidationMessage = (state) =>
  state.deepScan.spqlQueryValidationMessage;
